import script from "./centralProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./centralProducts.vue?vue&type=script&setup=true&lang=js"

import "./centralProducts.vue?vue&type=style&index=0&id=aa09e16a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa09e16a"]])

export default __exports__